module.exports = __webpack_public_path__ + "static/img/best_game.14385681.png";